import Link from 'next/link';

import { INavLinkItemProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Shows a clickable navigation link within the navigation bar.
 * To be use on public facing pages.
 *
 * @param INavLinkItemProps
 * @returns JSX.Element
 */
export function NavLinkItem({
  altTitle,
  className = '',
  isEnabled = true,
  label,
  labelExtra,
  to,
}: INavLinkItemProps) {
  return isEnabled ? (
    <Link
      href={to}
      title={altTitle || label}
      className={`
        inline-block rounded-lg px-2 py-1 text-sm text-slate-700
        transition-all duration-100 hover:bg-red-100 hover:text-red-900
        focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-1
        focus-visible:outline-red-100 active:bg-red-100 active:text-red-900
        ${className}
      `}
    >
      {label}
      <span>
        {labelExtra && (
          <span className="hidden pl-1 lg:inline">{labelExtra}</span>
        )}
      </span>
    </Link>
  ) : null;
}
